import { Button } from '@progress/kendo-react-buttons';
import { ToggleButton } from '@progress/kendo-react-dateinputs';
import React from 'react';
import ConstraintsList from '../../../../../components/constraints-list/ConstraintsList';
import { JoinOutline, LinkSolid } from '../../../../../icons/icons';
import { useEvent } from '../../../../contexts/event-bus';
import { useAppDispatch, useAppSelector } from '../../../../hooks/store-hooks';
import { setSetting } from '../../../../state/slices/settings-slice';

export function ConstraintsToolbarItem() {
    const visible = useAppSelector((x) => x.settings.toolbarShowConstraints);
    const showConstraintsOnMap = useAppSelector((x) => x.settings.constraintsShowOnMap);
    const [showConstraintsList, setShowConstraintsList] = React.useState(false);
    const isPlayback = useAppSelector((x) => x.global.playback.active);
    const dispatch = useAppDispatch();

    useEvent(
        'toggle-constraints-list',
        React.useCallback(() => {
            setShowConstraintsList((v) => (v ? false : !isPlayback));
        }, [isPlayback])
    );

    if (!visible) {
        return <></>;
    }

    return (
        <div className="telerik-button-group" id="main-constraints">
            <ToggleButton
                togglable={true}
                data-tooltip-bottom
                selected={showConstraintsOnMap}
                onClick={() => dispatch(setSetting('constraintsShowOnMap', !showConstraintsOnMap))}
                id="constraints-toggle"
                title="Show constraints on map (Airport Delays & FCAs)"
                svgIcon={LinkSolid}
            />
            <Button
                title="Show constraints list"
                data-tooltip-bottom
                id="constraint-list-btn"
                svgIcon={JoinOutline}
                disabled={isPlayback}
                onClick={() => setShowConstraintsList(true)}
            />
            {showConstraintsList && <ConstraintsList onClose={() => setShowConstraintsList(false)} />}
        </div>
    );
}
